import { Alert, Button } from "antd"
import React from "react"

import { useAppSelector } from "../../../hooks/use-app-selector"
import { selectSetupStatus } from "../redux/branches.slice.ts"

/**
 * The Home-level counterpart to `BranchSetupReminder` (which only ever
 * showed on the Settings → Branches page) — surfaces the exact same
 * `setupStatus` an owner would otherwise have to go find in Settings.
 * Renders nothing under the identical gate `BranchSetupReminder` already
 * uses: no status yet, setup done, or a single-operation account
 * (`target <= 1`).
 */
export function ContinueBranchSetupBanner({
  onContinueSetup
}: {
  onContinueSetup: () => void
}) {
  const status = useAppSelector(selectSetupStatus)

  if (!status || status.done || status.target <= 1) {
    return null
  }

  return (
    <Alert
      type="info"
      showIcon
      message={`Set up your branches — ${status.created} of ${status.target} configured`}
      description="Finish naming and configuring your branches to unlock the full multi-branch workspace."
      action={
        <Button size="small" type="primary" onClick={onContinueSetup}>
          Continue setup
        </Button>
      }
    />
  )
}
